"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var moment_1 = __importDefault(require("moment"));
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
var date_time_all_1 = require("../../date/date-time-all");
var kotlin_map_factory_1 = require("../../util/kotlin-map-factory");
var dateFormat = "YYYY-MM-DD";
/******************************************** LOGGING *********************************************/
var util_1 = require("util");
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('schedules.ts', shared_1.Styles.bracelet, util_1.inspect);
/******************************************** HELPERS *********************************************/
/**
 * Schedule factory: construct Schedule object from data in schedules.json
 */
var buildSchedule = function (schedule) {
    return new javelin_exports_1.Schedule(schedule.scheduleId, kotlin_map_factory_1.dirtyKotlinMap(schedule.names), kotlin_map_factory_1.dirtyKotlinMap(schedule.descriptions), kotlin_map_factory_1.dirtyKotlinMap(schedule.links), schedule.region, schedule.startDate ? new date_time_all_1.LocalDate(moment_1.default(schedule.startDate, dateFormat)) : undefined, schedule.endDate ? new date_time_all_1.LocalDate(moment_1.default(schedule.endDate, dateFormat)) : undefined);
};
/****************************************** DATA EXPORT *******************************************/
// Memoized array of ScheduleInstance objects built from raw content data
var _schedules;
/**
 * Export array of Schedule objects {@TODO Make Schedule object build & export lazy}
 * Build collection on 1st run, then memoize (the content data is immutable)
 */
exports.schedules = function (rawContentData) {
    _schedules = _schedules || rawContentData.schedules.map(buildSchedule);
    log.info("schedules:", util_1.inspect(_schedules, false, 10, true));
    return _schedules;
};
//# sourceMappingURL=schedules.js.map